module.exports = __webpack_public_path__ + "static/media/DSC_0364.b01053f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0364.jpg
// module id = 577
// module chunks = 0